import DatabaseReference from '../platform/DatabaseReference';
import Keys from './ConfigKeys';

export default class Config extends DatabaseReference {
  get childReferenceType() {
    return Keys;
  }
}
